import { FunctionComponent } from 'react';
import { PersonalAccount as PersonalAccountWidget } from 'widgets/PersonalAccount';
import { PageWrapper } from 'pages/_layouts/PageWrapper';

export const PersonalAccount: FunctionComponent = () => {
	return (
		<PageWrapper>
			<PersonalAccountWidget />
		</PageWrapper>
	);
};
